// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Informer_Wrapper__exI48"};